import React, { useRef, useEffect } from 'react';
import { images } from '../shared/assets';
import { initializeDragScroll } from '../../utils/interactiveFeatures';
import './ReEnergizeCarousel.css';

const ReEnergizeCarousel: React.FC = () => {
  const carouselRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (carouselRef.current) {
      const cleanup = initializeDragScroll('wellness-carousel');
      return () => {
        if (cleanup) cleanup();
      };
    }
  }, []);

  return (
    <section className="wellness-carousel horizontal-scroll-carousel" data-scroll-section>
      <div 
        id="wellness-carousel"
        className="wellness-carousel__container horizontal-scroll-carousel__scroll-container"
        ref={carouselRef}
      >
        {/* Panel 1: Split panel with large image and text */}
        <div className="wellness-carousel__panel wellness-carousel__panel--diptych">
          {/* Left side: Large image */}
          <div 
            className="wellness-carousel__image-left"
            style={{ backgroundImage: `url('${images.reEnergizePage.rectangle1}')` }}
          />
          
          {/* Right side: Content area with text and small image */}
          <div className="wellness-carousel__content-right">
            <div className="wellness-carousel__text-block">
              <h2>We create holistic travel experiences</h2>
              <p>
                Pellentesque purus eget elementum aliquet. Sed fames placerat vel ipsum ullamcorper nibh non faucibus orci. Scelerisque iaculis pulvinar facilisi morbi tellus. Diam nisi sagittis proin enim. A cursus eget feugiat vel blandit morbi adipiscing amet. Tempus ultricies nec facilisi elementum aenean enim vehicula ipsum tincidunt.
              </p>
              <div className="wellness-carousel__contact-link">
                <span>CONTACT US</span>
              </div>
            </div>
            
            {/* Small image in bottom-right */}
            <div 
              className="wellness-carousel__image-small"
              style={{ backgroundImage: `url('${images.reEnergizePage.rectangle11}')` }}
            />
          </div>
        </div>

        {/* Panel 2: Full-screen Yoga/Meditation room */}
        <div className="wellness-carousel__panel wellness-carousel__panel--fullscreen">
          <div 
            className="wellness-carousel__image-full"
            style={{ backgroundImage: `url('${images.reEnergizePage.rectangle1}')` }}
          />
        </div>

        {/* Panel 3: Turquoise panel with watermark and collage */}
        <div className="wellness-carousel__panel wellness-carousel__panel--turquoise">
          {/* Watermark background */}
          <div className="wellness-carousel__watermark">
            <img 
              src={images.reEnergizePage.reEnergizeWatermark} 
              alt="" 
              className="wellness-carousel__watermark-svg"
            />
          </div>
          
          <div className="wellness-carousel__turquoise-left">
            <div className="wellness-carousel__turquoise-content">
              <h3>Land of many stories</h3>
              <p>
                Pellentesque purus eget elementum aliquet. Sed fames placerat vel ipsum ullamcorper nibh non faucibus orci. Scelerisque iaculis pulvinar facilisi morbi tellus. Diam nisi sagittis proin enim. A cursus eget feugiat vel blandit morbi adipiscing amet. Tempus ultricies nec facilisi elementum aenean enim vehicula ipsum tincidunt.
              </p>
            </div>
          </div>
          <div className="wellness-carousel__turquoise-right">
            <div className="wellness-carousel__image-collage">
              <img src={images.reEnergizePage.rectangle1491} className="wellness-carousel__collage-img1" alt="" />
              <img src={images.reEnergizePage.rectangle1492} className="wellness-carousel__collage-img2" alt="" />
              <img src={images.reEnergizePage.rectangle1493} className="wellness-carousel__collage-img3" alt="" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReEnergizeCarousel;